import {
  Autocomplete,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import api, { CreateAccGroupRequest } from "../../api";
import { selectUser } from "../../slices/user";
import { AccessGroupsData } from "../../api/models/access-groups";

interface UserInfo {
  key: string;
  name: string;
  id: number;
}

interface BlockUserAccessGroupProps {
  selectedAccessGroup: AccessGroupsData | null;
  extraFunc: () => void;
}

const BlockUserAccessGroup = ({
  selectedAccessGroup,
  extraFunc,
}: BlockUserAccessGroupProps) => {
  const user = useAppSelector(selectUser);
  const labels = useAppSelector(selectLabels);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [users, setUsers] = React.useState<UserInfo[]>([]);
  const [selectedUser, setSelectedUser] = React.useState<UserInfo | null>(null);
  const [userInputValue, setUserInputValue] = React.useState<string>("");

  const defaultUnitsProps = {
    options: users ? users : [],
    getOptionLabel: (option: UserInfo) => option.name,
  };

  React.useEffect(() => {
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getUsers = async () => {
    try {
      setIsLoading(true);
      const response = await api.usersListRequest(
        "",
        user?.property?.id,
        null,
        "host",
        "secondary_host"
      );
      if (response) {
        const fixedResponse: UserInfo[] = response.map((item) => {
          return {
            key: `${item?.id}`,
            name: item?.name,
            id: item?.id,
          };
        });
        setUsers(fixedResponse);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const blockUser = async () => {
    if (selectedUser && selectedAccessGroup) {
      const bannedUsers =
        selectedAccessGroup?.banned_users?.map(
          (item) => item?.id
        ) || [];
      bannedUsers.push(selectedUser?.id);
      const payload: CreateAccGroupRequest = {
        data: {
          banned_users: bannedUsers,
          configuration: selectedAccessGroup?.configuration,
        },
      };
      try {
        setIsLoading(true);
        const response = await api.updateAccessGroupRequest(
          selectedAccessGroup?.documentId,
          payload
        );
        if (response) {
          extraFunc();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="w-100" style={{ minWidth: 300 }}>
      {isLoading ? (
        <div
          className="w-100 flex align-items-center justify-content-center"
          style={{ height: 100 }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="w-100">
          <p className="t-nowrap body-text-xs mb-3">{labels.search_user}</p>
          <Autocomplete
            {...defaultUnitsProps}
            autoComplete
            value={selectedUser}
            onChange={(event: any, newValue: UserInfo | null) => {
              setSelectedUser(newValue);
            }}
            inputValue={userInputValue}
            onInputChange={(event, newInputValue) => {
              setUserInputValue(newInputValue);
            }}
            id="Origen refactor"
            size="small"
            renderInput={(params) => <TextField {...params} />}
          />
          <div className="w-100 mt-8">
            <Button
              fullWidth
              variant="contained"
              disabled={isLoading ? true : !selectedUser}
              onClick={blockUser}
            >
              {labels.block}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockUserAccessGroup;
